export async function getStudentAllClasses(jwt: string): Promise<any> {
    if (!jwt) {
        return { status: 401, error: "JWT has expired" };
    }
    // Successful response
    return {
        status: 200,
        data: [
            {
                id: 1,
                name: "Class One",
                teacher_id: 6,
                auth_code: "AA111",
                entity_id: 1,
                entity_type: "institution",
                patients_discharged: 0,
                patients_seen: 1,
                date_created: "2025-02-13T04:44:45.235085"
            },
            {
                id: 2,
                name: "Class Two",
                teacher_id: 6,
                auth_code: "BB111",
                entity_id: 1,
                entity_type: "institution",
                patients_discharged: 0,
                patients_seen: 0,
                date_created: "2025-02-13T04:44:45.235085"
            },
        ],
    };
}
